
import SeoDataMixin from '@Mixins/seo-data';
import errorHandler from '@Utils/error-handler';
import { adapterEditoPage } from '@Adapters/cms/edito.adapter';

export default {
  name: 'EditoPage',
  mixins: [SeoDataMixin],
  async asyncData(context) {
    const { $publicAPI, error, route } = context;

    try {
      const data = await $publicAPI.cms.getEntry('edito_page_with_topmenu', {
        params: {
          pageGroup: route.params.section,
          targetPage: `/${route.params.name || ''}`,
        },
      });
      const pageData = adapterEditoPage(data, context);

      if (!pageData) {
        return error({ statusCode: 404 });
      }

      return pageData;
    } catch (err) {
      errorHandler(err, context, {
        logOnly: true,
        path: 'pages.edito.edito.asyncData',
      });

      return error(err);
    }
  },
  data() {
    return {
      content: undefined,
      footnotes: undefined,
      header: undefined,
      navigation: undefined,
      seo: undefined,
    };
  },
  computed: {
    currentPage() {
      return this.$route.path;
    },
  },
};
